import { useUserStore } from '@/stores/system'
import type { RouteRecordRaw } from 'vue-router'

export const logout: RouteRecordRaw = {
	children: [],
	name: 'logout',
	path: '/logout',
	meta: {
		auth: true,
		icon: 'fas fa-sign-out-alt',
		nav: false,
		ordering: 10,
		title: 'Abmeldung',
	},
	beforeEnter() {
		useUserStore().logout()
	},
}
